
import Vue from 'vue'
import IconButtonWrapper from '@/components/IconButtons/IconButtonWrapper.vue'

export default Vue.extend({
  components: { IconButtonWrapper },
  props: { color: { type: String, required: true } },
})
